// ─────────────────────────────────────────────────────────────
// src/App.js
// ─────────────────────────────────────────────────────────────
import React from "react";
import { initGA, trackPageView } from "./ga"; // path to ga/index.js
import { useEffect } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

/* ---------- mini‑tool assets ---------- */
import VideoBGRemover from "./pages/VideoBGRemover";   // ← page, not the inner tool component
import AnyToAnyConverterPage from "./pages/AnyToAnyConverter";

/* ---------- layout & shared UI ---------- */
import Header from "./components/Header";
import Footer from "./components/Footer";

/* ---------- home‑page sections ---------- */
import HomePage from "./pages/HomePage"; 

/* ---------- core‑feature pages ---------- */
import Scheduling from "./pages/Scheduling";
import Engagements from "./pages/Engagements";
import Analytics from "./pages/Analytics";
import AiAutomation from "./pages/AiAutomation";

/* ---------- solution pages ---------- */
import ManageSocialMedia from "./pages/ManageSocialMedia";
import GatherDeepInsights from "./pages/GatherDeepInsights";
import DriveMoreSales from "./pages/DriveMoreSales";
import BrandAwareness from "./pages/BrandAwareness";
import PersonalisedCustomerCare from "./pages/PersonalisedCustomerCare";

/* ---------- mini‑tool pages ---------- */
import BGRemover from "./pages/BGRemover";
import CaptionGenerator from "./pages/CaptionGenerator";
import SocialCalendar from "./pages/SocialCalendar";

/* ---------- platform pages ---------- */
import Instagram from "./pages/Instagram";
import Facebook from "./pages/Facebook";
import Twitter from "./pages/Twitter";
import GoogleMyBusiness from "./pages/GoogleMyBusiness";
import YouTube from "./pages/YouTube";
import Pinterest from "./pages/Pinterest";
import LinkedIn from "./pages/LinkedIn";

/* ---------- misc pages ---------- */
import ScheduleADemo from "./pages/ScheduleADemo";
import Blog from "./pages/Blog";
import AllArticle from "./pages/AllArticle";
import BlogPage from "./pages/BlogPage";
import CategoryPage from "./pages/CategoryPage";
import AuthorProfile from "./pages/AuthorProfile";
import PricingPage from "./pages/PricingPage";


import UserAgreement      from "./pages/UserAgreement";
import TermsAndConditions  from "./pages/TermsAndConditions";
import PrivacyPolicy       from "./pages/PrivacyPolicy";


import Ozone from "./pages/Ozone";

import AllMiniTools from "./pages/AllMiniTools";
import AffiliateProgram from "./pages/AffiliateProgram";

function GAListener({ children }) {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return children;
}
/* ----------------------------------------------------------- */
/* root component                                              */
/* ----------------------------------------------------------- */
function App() {


  return (
    <HelmetProvider>
      <Router>
      <GAListener>
        <div className="app-wrapper">
          <Header />
          {/* ✅ ADD STICKY FOOTER BACK TO THE LAYOUT */}

          <Routes>
            {/* HOME */}
            <Route path="/" element={<HomePage />} /> 

            {/* CORE FEATURES */}
            <Route path="/scheduling" element={<Scheduling />} />
            <Route path="/engagements" element={<Engagements />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/ai-automation" element={<AiAutomation />} />

            {/* PLATFORM */}
            <Route path="/instagram" element={<Instagram />} />
            <Route path="/facebook" element={<Facebook />} />
            <Route path="/twitter" element={<Twitter />} />
            <Route path="/google-my-business" element={<GoogleMyBusiness />} />
            <Route path="/youtube" element={<YouTube />} />
            <Route path="/pinterest" element={<Pinterest />} />
            <Route path="/linkedin" element={<LinkedIn />} />

            {/* SOLUTIONS */}
            <Route path="/manage-social-media" element={<ManageSocialMedia />} />
            <Route path="/gather-deep-insights" element={<GatherDeepInsights />} />
            <Route path="/drive-more-sales" element={<DriveMoreSales />} />
            <Route path="/brand-awareness" element={<BrandAwareness />} />
            <Route
              path="/personalised-customer-care"
              element={<PersonalisedCustomerCare />}
            />

            {/* MINI‑TOOLS */}
            <Route path="/mini-tools" element={<AllMiniTools />} />



            <Route path="/bg-remover" element={<BGRemover />} />
            <Route path="/caption-generator" element={<CaptionGenerator />} />
            <Route path="/social-calendar" element={<SocialCalendar />} />
            <Route path="/video-bg-remover"   element={<VideoBGRemover />} />
            <Route path="/any-to-any-converter" element={<AnyToAnyConverterPage />} />
            <Route path="/ozone" element={<Ozone />} />


            {/* PRICING & PARTNERS */}
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/affiliate-program" element={<AffiliateProgram />} />

            {/* BLOG */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/all-articles" element={<AllArticle />} />
            <Route path="/blog/category/:categorySlug" element={<CategoryPage />} />
            <Route path="/blog/author/:authorId" element={<AuthorProfile />} />
            <Route path="/blog/:slug" element={<BlogPage />} />

            {/* DEMO */}
            <Route path="/schedule-demo" element={<ScheduleADemo />} />


            <Route path="/user-agreement" element={<UserAgreement />} />
            <Route path="/terms"          element={<TermsAndConditions />} />
            <Route path="/privacy"        element={<PrivacyPolicy />} />
            {/* fall‑back */}
            <Route path="*" element={<HomePage />} />
          </Routes>

          <Footer />
        </div>
        </GAListener>
      </Router>
    </HelmetProvider>
  );
}

export default App;